

export const PARAMETRIZACION_FORMULARIO_LOGIN  = {
    numeroDocumento: {
        tipoDocumento: {
            "CC": {
                nombre: "Cédula de ciudadanía",
                patron: /^[0-9a-zA-Z]{2,30}$/,
                mensaje: "El campo ‘Número de documento’ no es válido"
            },
            "CE": {
                nombre: "Cédula de extranjería",
                patron: /^[0-9a-zA-Z]{2,30}$/,
                mensaje: "El campo ‘Número de documento’ no es válido"
            },
            "NIT": {
                nombre: "Número de identificación tributaria",
                patron: /^[0-9a-zA-Z]{2,30}$/,
                mensaje: "El campo ‘Número de documento’ no es válido"
            },
            "PA": {
                nombre: "Pasaporte",
                patron: /^[0-9a-zA-Z]{2,30}$/,
                mensaje: "El campo ‘Número de documento’ no es válido"
            },
            "TI": {
                nombre: "Tarjeta de identidad",
                patron: /^[0-9a-zA-Z]{2,30}$/,
                mensaje: "El campo ‘Número de documento’ no es válido"
            },
            "CD": {
                nombre: "Carnet Diplomático",
                patron: /^[0-9a-zA-Z]{2,30}$/,
                mensaje: "El campo ‘Número de documento’ no es válido"
            },
            "CA": {
                nombre: "Cédula antigua",
                patron: /^[0-9a-zA-Z]{2,30}$/,
                mensaje: "El campo ‘Número de documento’ no es válido"
            }
        },
        required: {
            mensaje: "El campo ‘Número de documento’ es obligatorio"
        }
    },
    tipoDocumento: {
        required: {
            mensaje: "El campo ‘Tipo de documento’ es obligatorio"
        }
    },
    contrasena: {
        required: {
            mensaje: "El campo ‘Contraseña’ es obligatorio"
        }
    }
}